var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"arrival nowrap white--text",attrs:{"color":"alert","rounded":"pill"}},[_c('div',{staticClass:"white--text size-10 roboto weight-600"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }